var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event",class:_vm.backgroundIsLight ? 'dark-text' : 'light-text',style:({
    'background-color': _vm.backgroundColor,
    width: _vm.eventWidth
  }),on:{"click":function($event){return _vm.$emit('edit-event', _vm.event)},"mouseenter":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_vm._v(" "+_vm._s(_vm.event.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }